module.exports = __webpack_public_path__ + "fonts/ca8d25cd-e264-4404-b271-4afc45c779c4.deda33b.woff";